<template>
  <div class="login-page">
    <div class="layer bg" id="login"></div>
    <div class="layer flex-center">
      <!-- logo部分 -->
      <div class="logo-group">
        <!--<img src="./image/logo-sc.png" alt="logo">-->
        <span class="login-title">{{loginTitle}}</span>
      </div>
      <!-- 表单部分 -->
      <div class="form-group">
        <el-card>
          <el-form ref="loginForm" label-position="top" :rules="rules" :model="formLogin" :show-message="false" :status-icon="false">
            <el-form-item  prop="username">
              <el-input type="text" v-model="formLogin.username" placeholder="用户名">
                <i slot="prepend" class="fa fa-user-o"></i>
              </el-input>
            </el-form-item>
            <el-form-item prop="password">
              <el-input type="password" v-model="formLogin.password" placeholder="密码" @keyup.enter.native="submit">
                <i slot="prepend" class="fa fa-lock"></i>
              </el-input>
            </el-form-item>
            <el-form-item v-if="isShowCode" prop="code">
              <el-input type="text" v-model="formLogin.code" placeholder="验证码" @keyup.enter.native="submit">
                <template slot="prepend">
                  <i class="fa fa-shield"></i>
                </template>
                <template slot="append">
                  <img class="login-code" :src="loginCodeUrl" @click="changeLoginCode" style="cursor: pointer">
                </template>
              </el-input>
            </el-form-item>
            <el-button @click="submit" type="primary" class="button-login" :loading="disabledSubmit">登录</el-button>
            <!--<div style="float: right;">
              <el-button type="text">注册用户</el-button>
            </div>-->
          </el-form>
        </el-card>
      </div>
      <!-- 快速登陆按钮 -->
      <el-button type="info" class="button-help" @click="dialogVisible = true">
        快速选择用户（测试功能）
      </el-button>
    </div>
    <el-dialog
      title="快速选择用户"
      :visible.sync="dialogVisible"
      width="400px">
      <el-row :gutter="10" style="margin: -20px 0px -10px 0px;">
        <el-col v-for="(user, index) in users" :key="index" :span="8">
          <div class="user-btn" @click="handleUserBtnClick(user)">
            <d2-icon name="user-circle-o"/>
            <span>{{user.name}}</span>
          </div>
        </el-col>
      </el-row>
    </el-dialog>
  </div>
</template>

<script>
/* eslint-disable */
require('particles.js')
import config from './config/default'
import { mapActions } from 'vuex'
import RSAUtils from '@/libs/security.js'

export default {
  data () {
    return {
      // 快速选择用户
      dialogVisible: false,
      // 是否显示验证码
      isShowCode: false,
      loginCodeUrl: '', //登录验证码地址
      disabledSubmit: false, // 禁用登陆按钮
      loginTitle: process.env.VUE_APP_TITLE,
      users: [
        {
          name: '管理员',
          username: 'super',
          password: '123!@#qwe'
        },
        {
          name: '编辑',
          username: 'editor',
          password: 'editor'
        },
        {
          name: '用户1',
          username: 'user1',
          password: 'user1'
        }
      ],
      // 表单
      formLogin: {
        username: '',
        password: '',
        code: ''
      },
      // 校验
      rules: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'change' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'change' }
        ],
        code: [
          { required: true, message: '请输入验证码', trigger: 'change' }
        ]
      }
    }
  },
  mounted () {
    // 初始化例子插件
    particlesJS('login', config)
      //初始化是否显示验证码区
      this.initIsShowCode()
  },
  methods: {
    ...mapActions([
      'd2adminLogin'
    ]),
    /**
     * @description 接收选择一个用户快速登陆的事件
     * @param {Object} user 用户信息
     */
    handleUserBtnClick (user) {
      this.formLogin.username = user.username
      this.formLogin.password = user.password
      this.submit()
    },
    /**
     * @description 提交表单
     */
    // 提交登陆信息
    submit () {
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          // 登陆
          // 注意 这里的演示没有传验证码
          // 具体需要传递的数据请自行修改代码

            //获取RSA信息
            this.$axios.get('/service/sso/keyPair')
                .then(res => {
                    if(res.code == 200){
                        let publicKey = RSAUtils.getKeyPair(res.body.exponent, '', res.body.modulus)
                        let encryptedPassword = RSAUtils.encryptedString(publicKey, this.formLogin.password)
                        this.d2adminLogin({
                            vm: this,
                            username: this.formLogin.username,
                            password: encryptedPassword,
                            code: this.formLogin.code
                        })
                    }
                })
                .catch(function (error) {
                    // handle error
                    console.log(error);
                })
                .then(function () {
                    // always executed
                });



        } else {
          // 登陆表单校验失败
          this.$message.error('表单校验失败')
        }
      })
    },
      initIsShowCode(){
          this.$axios.get('/service/sso/code')
              .then(res => {
                  //示例：{"code":200,"message":"成功","body":true,"timestamp":1542275174564}
                  if(res.code == 200){
                      this.isShowCode = res.body
                      if(this.isShowCode){
                          this.changeLoginCode()
                      }
                  }
              })
              .catch(function (error) {
                  // handle error
                  console.log(error);
              })
              .then(function () {
                  // always executed
              });
      },
      changeLoginCode(){
          this.loginCodeUrl = "/service/sso/code/100/48/5/35/26?" + Math.random()
      }
  }
}
</script>

<style lang="scss">
@import './style.scss';
</style>
